"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_loops_1 = require("react-loops");
const reactstrap_1 = require("reactstrap");
const useNumber_1 = tslib_1.__importDefault(require("react-hanger/array/useNumber"));
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const react_2 = require("@osmosys/react");
// General scroll to element function
exports.WorkspaceDashboard = ({ workspace }) => {
    // Router
    const { history, match } = use_react_router_1.default();
    // Active dashboard
    const [activeUrlIndex, activeUrlNumberActions] = useNumber_1.default(match.params.activeUrlIndex ? parseInt(match.params.activeUrlIndex, 10) : 1, {
        lowerLimit: 1,
        upperLimit: workspace.dashboardUrls.length,
    });
    const hasDashboards = !workspace.dashboardUrls ||
        !Array.isArray(workspace.dashboardUrls) ||
        workspace.dashboardUrls.length === 0 ||
        !workspace.dashboardUrls[activeUrlIndex - 1];
    // Update path
    react_1.useEffect(() => {
        if (hasDashboards) {
            const newPath = `/workspace/dashboards/${activeUrlIndex}`;
            if (newPath !== history.location.pathname) {
                history.push(`/workspace/dashboards/${activeUrlIndex}`);
            }
        }
    }, [hasDashboards, activeUrlIndex, history]);
    const ref = react_1.useRef();
    // Scroll to
    // useEffect(() => {
    //   if (ref && ref.current) {
    //     const t = setTimeout(() => {
    //       const el = document.querySelector('.osmosys-scroll-container');
    //       el.scrollTo(0, el.clientHeight);
    //     }, 20);
    //     return () => {
    //       clearTimeout(t);
    //     };
    //   }
    //   return () => {};
    // }, [ref && ref.current]);
    // No dashboards found
    if (hasDashboards) {
        return (react_1.default.createElement("div", { className: "flex-full-col-centered" },
            react_1.default.createElement("p", { className: "lead my-2 text-center" }, "No dashboards found")));
    }
    return (react_1.default.createElement("div", { ref: ref, className: "flex-full-row" },
        react_1.default.createElement("div", { className: "flex-col-centered" },
            react_1.default.createElement(react_loops_1.For, { of: workspace.dashboardUrls }, (item, { index }) => {
                return (react_1.default.createElement("div", { className: "m-1" },
                    react_1.default.createElement(react_2.OsmosysTooltip, { label: `Dashboard ${index + 1} - ${item.replace(/https?:\/\//, '')}` },
                        react_1.default.createElement(reactstrap_1.Button, { color: activeUrlIndex === index + 1 ? 'dark' : 'link', onClick: () => {
                                activeUrlNumberActions.setValue(index + 1);
                            } }, index + 1))));
            })),
        react_1.default.createElement("div", { className: "flex-grow-1 d-flex rounded-sm border overflow-hidden bg-white" },
            react_1.default.createElement("iframe", { style: {
                    backgroundColor: 'transparent',
                    minHeight: window.innerHeight - 60,
                }, src: workspace.dashboardUrls[activeUrlIndex - 1], className: "border-0 p-0 m-0 flex-grow-1" }))));
};
//# sourceMappingURL=WorkspaceDashboard.js.map